import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useT } from "@/context/I18nContext";
import { PLAY_STORE_URL, detectPlatform } from "@/lib/device";
import { PlayStoreButton, IosComingSoon } from "@/components/common/AppDownloadPrompt";
import { MessageCircle, ClipboardCheck, LineChart, ShieldCheck } from "lucide-react";

/** Public /download page — no login required. Device-aware CTA, QR for desktop. */
export default function Download() {
  const t = useT();
  const platform = detectPlatform();
  useEffect(() => { document.title = `${t("download.title")} — Inner Compass`; }, [t]);
  const points = [
    { icon: MessageCircle, k: "download.p1" }, { icon: ClipboardCheck, k: "download.p2" },
    { icon: LineChart, k: "download.p3" }, { icon: ShieldCheck, k: "download.p4" },
  ];
  return (
    <div className="mx-auto max-w-5xl px-6 py-12 md:py-20" data-testid="download-page">
      <div className="grid grid-cols-1 md:grid-cols-[1.3fr_1fr] gap-10 items-center">
        <div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.15em] text-ink-500 mb-3">{t("download.eyebrow")}</div>
          <h1 className="font-heading text-4xl sm:text-5xl leading-tight tracking-tight text-ink-900">{t("download.title")}</h1>
          <p className="mt-4 text-ink-500 max-w-xl text-base">{t("download.body")}</p>
          <ul className="mt-8 space-y-3">
            {points.map(({ icon: Icon, k }) => (
              <li key={k} className="flex items-start gap-3 text-sm text-ink-700"><Icon className="h-5 w-5 text-sage-700 shrink-0" strokeWidth={1.5} />{t(k)}</li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {platform !== "ios" && <PlayStoreButton testId="download-page-android" />}
            <IosComingSoon testId="download-page-ios-soon" />
          </div>
          <p className="mt-4 text-xs text-ink-500">{t("download.noAccount")}</p>
        </div>
        <div className="rounded-3xl bg-ink-900 text-cream-50 p-8 flex flex-col items-center text-center shadow-card" data-testid="download-qr-card">
          <div className="rounded-2xl bg-white p-3"><QRCodeSVG value={PLAY_STORE_URL} size={180} level="M" /></div>
          <div className="mt-5 font-heading text-lg">{t("download.scanTitle")}</div>
          <p className="mt-1 text-sm text-cream-50/75">{t("download.scan")}</p>
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="mt-4 text-xs text-cream-50/60 underline break-all" data-testid="download-qr-link">{PLAY_STORE_URL}</a>
        </div>
      </div>
    </div>
  );
}
